import React from 'react';
import Moment from 'moment';
//material
import { Card, CardContent, withStyles, Typography, Grid, Button } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
//utils
import { TeamPlayStatus } from '../../../utils/constants';
//styles
import styles from './next-match-styles';
//components
import Avatar from '../../avatar';

function NextMatchView (props) {
  const classes = props.classes;
  const isBye = props.results.length > 0 && props.results[0].isBye;

  let homeTeam, awayTeam;
  if (!props.isLoading && props.details.nextOpponent) {
    homeTeam = props.details.nextOpponent.isHome ? props.opponent : props.details;
    awayTeam = !props.details.nextOpponent.isHome ? props.opponent : props.details;
  }

  return (
    <Card className={classes.card}>
      <CardContent className={(!props.isLoading && TeamPlayStatus.Playing === props.details.teamPlayStatus.id) ? classes.vsCard : ''}>
        {
          !props.isLoading &&
            <div className={classes.title}>
              Next Match
            </div>
        }

        {
          !props.isLoading &&
          <div>
            {
              TeamPlayStatus.Won === props.details.teamPlayStatus.id &&
              <div className={classes.defaultText}>
                You Won the Bracket!
              </div>
            }

            {
              TeamPlayStatus.Eliminated === props.details.teamPlayStatus.id &&
              <div className={classes.defaultText}>
                You Have Been Eliminated
              </div>
            }

            {
              TeamPlayStatus.Undrawn === props.details.teamPlayStatus.id &&
              <div className={classes.textContainer}>
                <Typography className={classes.opponentXlText + ' ' + classes.largeTextMargin}>Waiting for the Draw</Typography>
                <Typography className={classes.opponentDrawDate}>Draw Date: { props.details.drawDate ? Moment(new Date(props.details.drawDate)).format('Do MMMM YYYY') : '-' }</Typography>
                <p className={classes.marginTop30}>You will receive an email when the draw has been made.</p>
              </div>
            }

            {
              TeamPlayStatus.Ready === props.details.teamPlayStatus.id &&
              <div className={classes.textContainer}>
                <Typography className={classes.opponentXlText + ' ' + classes.largeTextMargin}>{ isBye ? 'You have a Bye!' : 'Waiting for Your Next Opponent'}</Typography>
                {
                  isBye &&
                  <Typography className={classes.opponentDrawDate}>Waiting for Your Next Opponent</Typography>
                }
                <p className={isBye ? classes.marginTop20 : classes.marginTop30}>You will receive an email when your opponent is ready.</p>
              </div>
            }

            {
              TeamPlayStatus.Playing === props.details.teamPlayStatus.id &&
              <div>
                <Grid container>
                  <Grid item xs={5} className={classes.teamGridItem}>
                    <div className={classes.pill}>Home</div>

                    {
                      props.isSingles ? (
                        <Avatar
                          className={classes.singleAvatar}
                          size={60}
                          src={homeTeam.leadPlayer.photoUrl}
                          alt={homeTeam.leadPlayer.name} />
                      ) : (
                        <div className={classes.teamAvatarContainer}>
                          <Avatar
                            size={55}
                            className={classes.additionalPlayerAvatar}
                            src={homeTeam.additionalPlayer.photoUrl}
                            alt={homeTeam.additionalPlayer.name} />

                          <Avatar
                            size={55}
                            className={classes.leadPlayerAvatar}
                            src={homeTeam.leadPlayer.photoUrl}
                            alt={homeTeam.leadPlayer.name} />

                        </div>
                      )
                    }

                    <div className={classes.teamName}>
                      {homeTeam.pairName}
                    </div>
                  </Grid>

                  <Grid item xs={2} className={classes.teamGridItem}>
                    <div className={classes.vsPill}>VS</div>
                  </Grid>

                  <Grid item xs={5} className={classes.teamGridItem}>
                    <div className={classes.pill}>Away</div>

                    {
                      props.isSingles ? (
                        <Avatar
                          className={classes.singleAvatar}
                          size={60}
                          src={awayTeam.leadPlayer.photoUrl}
                          alt={awayTeam.leadPlayer.name} />
                      ) : (
                        <div className={classes.teamAvatarContainer}>
                          <Avatar
                            size={55}
                            className={classes.additionalPlayerAvatar}
                            src={awayTeam.additionalPlayer.photoUrl}
                            alt={awayTeam.additionalPlayer.name} />

                          <Avatar
                            size={55}
                            className={classes.leadPlayerAvatar}
                            src={awayTeam.leadPlayer.photoUrl}
                            alt={awayTeam.leadPlayer.name} />

                        </div>
                      )
                    }

                    <div className={classes.teamName}>
                      {awayTeam.pairName}
                    </div>
                  </Grid>

                  <Grid item xs={12} className={classes.homeClub}>{homeTeam.clubName}</Grid>

                  <Grid item xs={12} className={classes.matchDeadline}>
                    Play&nbsp;By:&nbsp;
                    {Moment(new Date(props.details.nextOpponent.matchDeadline)).format(
                      'Do MMMM YYYY',
                    )}
                  </Grid>

                  <Button
                    color={'primary'}
                    size={'small'}
                    aria-label={'small'}
                    variant={'contained'}
                    className={classes.viewOpponentsButton}
                    onClick={() => props.handleSetViewOpponent(true)}>
                    View Opponents
                  </Button>
                </Grid>
              </div>
            }
          </div>
        }

        {
          props.isLoading &&
            <div>
              <Skeleton className={classes.alignSelfCenter} height={50} width={'80%'}/>
              <Skeleton className={classes.alignSelfCenter} height={20} width={80}/>
              <Skeleton className={classes.alignSelfCenter} height={20} width={100}/>
              <Skeleton className={classes.alignSelfCenter} height={20} width={80}/>

              <br/>
              <Skeleton className={classes.alignSelfCenter} height={30} width={'70%'}/>
              <Skeleton className={classes.alignSelfCenter} height={30} width={'60%'}/>
            </div>
        }

      </CardContent>
    </Card>
  )
}

export default withStyles(styles) (NextMatchView)
